import styled from 'styled-components';
import { StyledFlagProps } from './Flag.types';

export const StyledFlag = styled.div<StyledFlagProps>`
  display: inline-block;
  line-height: 0;

  .flag__holder {
    height: 25px;
    width: 25px;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  ${(props) => props.customStyle}
`;
